import React from 'react';
import styled from '@emotion/styled';
import breakpoints from '../Theme/breakpoints';
import Skeleton from './Skeleton';
import { TextSkeletons } from './HomePage';

const JobsContainer = styled.div`
  width: 970px;
  box-sizing: border-box;
  margin: 0 auto;

  @media (min-width: ${breakpoints.sm}px) {
    padding: 1.5rem;
  }
`;

const JobsHeaderContainer = styled.div`
  padding: 1.5rem 1.5rem 0;

  @media (min-width: ${breakpoints.sm}px) {
    padding: 0;
  }
`;

const BackToList = styled.div`
  display: inline-block;
  height: 1.5rem;

  .MuiSkeleton-root {
    width: 20vw;
  }
`;

const JobsHeader = styled.div`
  padding: 2.5rem 0 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: -1.5rem 0 1.5rem;
  min-height: calc(100vh - 139px);

  .MuiSkeleton-root {
    &:first-of-type {
      width: 40vw;
      max-width: 200px;
      margin: 0 auto;
    }
    &:last-of-type {
      width: 60vw;
      max-width: 500px;
      margin: 18px auto 36px;
    }
  }

  @media (min-width: ${breakpoints.sm}px) {
    min-height: auto;
  }
`;

const JobsBreadcrumbs = styled.div`
  display: none;

  @media (min-width: ${breakpoints.sm}px) {
    display: block;
    height: 1.5rem;
    padding: 0;
    margin: .25rem 0 0 0;
    width: 100%;
    overflow: hidden;
    position: relative;
  }
`;

const JobsMain = styled.div`
  margin-top: 0;
  padding: 1.5rem;
  border-bottom: 1px solid var(--grey-light);
  border: 1px solid var(--grey-light);

  @media (min-width: ${breakpoints.md}px) {
    width: 100%;
  }
`;

const ImageSkeleton = styled(Skeleton)`
  margin: auto;
  width: 50vw;

  @media (min-width: ${breakpoints.md}px) {
    width: 600px;
  }
`;

const HeaderSkeleton = styled(Skeleton)`
  margin: 1.5rem auto 2.5rem auto;

  width: 80vw;

  @media (min-width: ${breakpoints.md}px) {
    width: 100%;
  }
`;

const JobDetailSkeletonLoader = () => (
  <JobsContainer>
    <JobsHeaderContainer>
      <BackToList>
        <Skeleton />
      </BackToList>
      <JobsHeader>
        <Skeleton height={28} />
        <Skeleton height={36} />
      </JobsHeader>
      <JobsBreadcrumbs>
        <Skeleton />
      </JobsBreadcrumbs>
    </JobsHeaderContainer>
    <JobsMain>
      <ImageSkeleton height={100} />
      <HeaderSkeleton height={30} />
      <TextSkeletons />
      <TextSkeletons />
      <TextSkeletons />
      <TextSkeletons />
    </JobsMain>
  </JobsContainer>
);

export default JobDetailSkeletonLoader;
